import { useQuery } from '@hooks/reactQuery';

import { getNonRequiredFieldsForAssetTypes } from '@api/assetTypes';

import { refetchOptions } from '@constants/common';
import { NON_REQUIRED_FIELDS } from '@constants/queryKeys';

export const useQueryNonRequiredFieldsForAssetType = () => {
	const {
		data: nonRequiredFields,
		isLoading: isLoadingNonRequiredFields,
	} = useQuery({
		queryKey: [NON_REQUIRED_FIELDS],
		queryFn: () => getNonRequiredFieldsForAssetTypes(),
		...refetchOptions,
	});

	return {
		nonRequiredFields,
		isLoadingNonRequiredFields,
	};
};
